<app-form-dialog-shell
  [icon]="isEditing ? 'edit' : 'person_add'"
  [heading]="isEditing ? 'Editar usuario' : 'Nuevo usuario'"
  [saving]="saving()"
  [saveLabel]="isEditing ? 'Guardar cambios' : 'Crear usuario'"
  [saveIcon]="isEditing ? 'save' : 'person_add'"
  formId="user-form"
  (cancelled)="close()"
  >
@if (isCreating) {
  <div class="info-banner">
    <mat-icon>mail</mat-icon>
    <span>Al crear el usuario, se le enviará la invitación con su contraseña temporal (correo o SMS según lo capturado).</span>
  </div>
}

<form id="user-form" [formGroup]="form" (ngSubmit)="onSubmit()">

      <div class="form-grid">

        <!-- Nombre -->
        <mat-form-field appearance="outline">
          <mat-label>Nombre completo</mat-label>
          <input matInput formControlName="name" placeholder="ej. Juan Pérez" />
          <mat-icon matPrefix>person</mat-icon>
          <mat-hint>Se guardará en mayúsculas</mat-hint>
          @if (fieldError('name')) {<mat-error>Nombre requerido (mín. 2 caracteres)</mat-error>}
        </mat-form-field>

        <!-- Email -->
        <mat-form-field appearance="outline">
          <mat-label>Correo electrónico</mat-label>
          <input matInput formControlName="email" type="email" placeholder="ej. juan@empresa.com" />
          <mat-icon matPrefix>email</mat-icon>
          @if (isEditing) {<mat-hint>El correo no se puede modificar</mat-hint>} @else {<mat-hint>Opcional si capturas teléfono</mat-hint>}
          @if (fieldError('email', 'email')) {<mat-error>Ingresa un correo válido</mat-error>}
        </mat-form-field>

        <!-- Teléfono (personal técnico sin correo empresarial) -->
        <mat-form-field appearance="outline">
          <mat-label>Teléfono celular</mat-label>
          <input matInput formControlName="phone" type="tel" placeholder="ej. 55 1234 5678" />
          <mat-icon matPrefix>smartphone</mat-icon>
          @if (isEditing && form.get('phone')?.disabled) {<mat-hint>Es su identificador de acceso: no se puede modificar</mat-hint>} @else {<mat-hint>Sin correo, el usuario inicia sesión con este número (invitación por SMS)</mat-hint>}
          @if (fieldError('phone', 'phoneFormat')) {<mat-error>Teléfono inválido: 10 dígitos o formato +52...</mat-error>}
        </mat-form-field>

        <!-- Rol -->
        <mat-form-field appearance="outline" class="full-col">
          <mat-label>Rol asignado</mat-label>
          <mat-select formControlName="role">
            <mat-option value="">Sin rol</mat-option>
            @for (role of availableRoles; track role.id) {
              <mat-option [value]="role.id">{{ role.name }}</mat-option>
            }
          </mat-select>
          <mat-icon matPrefix>badge</mat-icon>
          @if (availableRoles.length === 0) {<mat-hint>No hay roles disponibles. Crea uno primero.</mat-hint>}
        </mat-form-field>

        <!-- Firma autógrafa (para autorizaciones, p. ej. BIO-01) -->
        @if (isEditing) {
          <div class="firma-field full-col">
            <span class="firma-label">Firma autógrafa</span>
            <div class="firma-row">
              @if (firmaPreviewUrl()) {
                <img [src]="firmaPreviewUrl()" alt="Firma" class="firma-preview" />
              } @else {
                <div class="firma-empty"><mat-icon>draw</mat-icon> Sin firma</div>
              }
              <button mat-stroked-button type="button"
                (click)="openFirmaManager()">
                <mat-icon>upload</mat-icon>
                {{ firmaPreviewUrl() ? 'Reemplazar' : 'Subir firma' }}
              </button>
              @if (firmaPreviewUrl()) {
                <button mat-icon-button color="warn" type="button" (click)="removeFirma()" matTooltip="Quitar firma">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
            <span class="firma-hint">PNG con fondo transparente recomendado. Se usa en la autorización de documentos.</span>
          </div>
        }

      </div>

      @if (form.hasError('emailOrPhoneRequired') && form.touched) {
        <div class="form-group-error">
          <mat-icon>error_outline</mat-icon>
          <span>Captura el correo electrónico o el teléfono del usuario.</span>
        </div>
      }

      

    </form>
</app-form-dialog-shell>
